module.exports = __webpack_public_path__ + "static/59-brain-jan2053-00151c64fef3199157320939c5c9ae59.jpg";